/**
 * @deprecated Use `IProcessedStyleSet` from `@uifabric/styling` or `@uifabric/merge-styles` instead.
 */
export type IClassNames<T> = { [key in keyof T]: string };
